import { mapKeys, mapValues, kebabCase } from 'lodash';

import Bridge from '../../Bridge';
import Configs from '../../Configs';

const getFontFamily = (fontName) => {
  const fontNames = Configs.get('tulip.fontNameMap', {});

  return fontName
    ? `${fontNames[fontName] || fontName}, -apple-system, sans-serif`
    : null;
};

export default function (url) {
  let fonts = Bridge.get('context.fonts', {});

  fonts = mapKeys(fonts, (value, key) => kebabCase(key));
  fonts = mapValues(fonts, getFontFamily);

  return {
    url,
    variables: fonts,
  };
}



// WEBPACK FOOTER //
// ./src/UI/presets/fonts.js